import { useEffect, useState } from "react";
import api from "../../../js/api";
import Button from "../../../components/Button/Button";
import { useParams } from "react-router-dom";
import './Question.scss';


export default function Question() {

    const params = useParams();
    const [users, setUsers] = useState([]);
    const [question, setQuestion] = useState(null);

    useEffect(() => {
        try {
            const id = params.questionID;
            if (!id) {
                return;
            }
            api.get('/newyear/users', { silent: true }).then((data) => {
                if (data.error) {
                    console.error('Error fetching users:', data.error);
                    return;
                }
                setUsers(data);
            });
            api.get(`/questions/${id}`, { silent: true }).then((qData) => {
                if (qData.error) {
                    console.error('Error fetching question data:', qData.error);
                    return;
                }
                setQuestion(qData);
            });
            console.log('question:', question);
        } catch (error) {
            console.error('Error fetching Año Nuevo data:', error);
        }
    }, [])

    return (
        <div id="question">
            <div className='centered-container gap'>
                {question ? <h2 className="width-80 text-center"><b>{question.question}</b></h2> : <i>No hay ninguna pregunta activa en este momento.</i>}
                {question?.is_active ? <i>Vota a una de las siguientes personas</i> : <i>La pregunta no está activa.</i>}
                {question && <p>Has votado a: <b>{question.your_vote}</b></p>}
                {
                    question?.is_active ? (
                        users.length === 0 ?
                            <p>No hay usuarios disponibles para votar.</p>
                            :
                            <div className="flex flex-wrap width-80 gap flex-center">
                                {users.map((user, index) => (
                                    <Button text={user.name + ' (' + user.login + ')'} key={index} onClick={async () => {
                                        if (!question) {
                                            alert('No hay una pregunta activa para votar.');
                                            return;
                                        }
                                        if (!question.is_active) {
                                            alert('La pregunta ya no está activa.');
                                            return;
                                        }
                                        console.log('Votando a:', user.id);

                                        const voteData = await api.post(`/user/questions/${question.id}/vote/${user.login}`);
                                        if (voteData.error) {
                                            alert('Error al votar: ' + voteData.error);
                                            return;
                                        }

                                        const qData = await api.get(`/questions/${question.id}`, { silent: true });
                                        if (qData.error) {
                                            console.error('Error fetching question data:', qData.error);
                                            return;
                                        }
                                        setQuestion(qData);
                                    }}>
                                    </Button>
                                ))}
                            </div>
                    ) : (
                        <>
                            <h3>Puntuación</h3>
                            {question && question.votes && typeof question.votes === 'object' ? (
                                <div className="flex flex-column gap width-80">
                                    {Object.keys(question.votes).map((userLogin, index) => {
                                        const user = users.find(u => u.login === userLogin);
                                        const userName = user ? user.name + ' (' + user.login + ')' : userLogin;
                                        return (
                                            <div key={index} className="flex gap flex-space-between score">
                                                <p>{userName}</p>
                                                <p><b>{question.votes[userLogin]} votos</b></p>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <p>No hay votos para esta pregunta.</p>
                            )}
                        </>
                    )
                }
            </div>
        </div>
    );
}